import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Indentation } from 'roosterjs-editor-types';
import { setIndentation } from 'roosterjs-editor-api';

const outdent: RibbonButton = {
    key: 'outdent',
    title: () => strings.outdent,
    imageSrc: require('../svg/outdent.svg'),
    imageRtlSrc: require('../svg/outdent-rtl.svg'),
    onExecute: (plugin, logUsage) => {
        setIndentation(plugin.getEditor(), Indentation.Decrease);
        logUsage('setIndentation', Indentation.Decrease);
    },
};

export default outdent;
